<template>
    <button
        ref="buttonRef"
        :class="twMerge(standardButtonVariants({ variant, size, loading, disabled, danger }), attrs.class)"
        :disabled="disabled"
        v-bind="attrs"
    >
        <!-- Leading icon -->
        <Icon v-if="props.leadingIcon" :name="props.leadingIcon" :size="iconSize" />

        <!-- Slot -->
        <slot />

        <!-- Loading spinner -->
        <Spinner v-if="props.loading" :size="props.size" />

        <!-- Trailing icon -->
        <Icon v-else-if="props.trailingIcon" :name="props.trailingIcon" :size="iconSize" />
    </button>
</template>

<script setup lang="ts">
import { computed, ref, useAttrs } from 'vue'
import { twMerge } from 'tailwind-merge'
import Icon from '../icon/Icon.vue'
import Spinner from '../spinner/Spinner.vue'
import { standardButtonVariants } from './buttonVariants'
import type { ButtonProps } from './types'

const attrs = useAttrs() as Record<string, string>

const props = withDefaults(defineProps<ButtonProps>(), {
    size: 'md',
    variant: 'primary',
})

const iconSize = computed(() => {
    if (props.size === 'sm') return 14
    if (props.size === 'md') return 16
    return 20 // lg
})

const buttonRef = ref<HTMLButtonElement>()

defineExpose({
    focus: () => buttonRef.value?.focus(),
})

</script>

<style scoped>
.spin {
  animation: spin 0.8s linear infinite;
}
</style>
